// register — en. Part of the en i18n bundle; merged by ./index.js

export default {
  fullName: 'Full Name *',
  email: 'Email',
  phone: 'Phone *',
  company: 'Company Name',
  businessType: 'Business Type',
  tin: 'TIN Number',
  elmis: 'E-LMIS Registration',
  submit: 'Submit Application',
  submitting: 'Submitting...',
  companyToggle: 'Send as a Company',
// Register,
  accountDetails: 'Account Details',
  businessInfo: 'Business Info',
  nextBusiness: 'Next: Business Info',
  nextDocs: 'Next: Documents',
  businessLicenseReq: 'Business license number is required.',
  licenseInfo: '📋 Your information will be reviewed by our team. You\'ll receive a welcome email after registration.',
  phoneLabel2: 'Phone Number *',
  emailLabel: 'Email Address (optional)',
  fullNameLabel: 'Full Name *',
  fillRequired: 'Please fill all required fields.',
  passwordShort: 'Password must be at least 6 characters.',
  companyRequired: 'Company name is required.',
  phoneLabel: 'Phone Number',
  passwordLabel: 'Password',
  phoneMustBe9: 'Phone must be 9 digits',
  alertFullNameRequired: 'Full name is required',
  alertPhoneDigits: 'Phone must be 9 digits (e.g. 911031884)',
  alertValidEmail: 'Please enter a valid email address',
  alertSubmissionFailed: 'Submission failed. Please try again.',
  alertCompanyRequired: 'Company name is required.',
  alertTinRequired: 'TIN number is required.',
  alertElmisRequired: 'E-LMIS registration is required.',
  alertBusinessTypeRequired: 'Business type is required.',
// Chat,
  businessTypeLabel: 'Business Type',
};

